import React from 'react'
import { Card, Typography } from '@chilecompra/react-kit/components'
import { REACT_APP_BASE_URL } from '../../config/settings/environment'
import { FINES_PENALTIES_FILE } from '../../config/settings/constants'
import {
  DownloadBreach,
  GridContainer,
  GridItem,
  IconArrowDownward,
  WrapperDownloadBreach
} from './QuoteBasicInformation.styles'

/**
 * Fines and penalties component.
 */
const FinesPenalties = () => {
  const filePath = `${REACT_APP_BASE_URL}/${FINES_PENALTIES_FILE}`

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card color="warning">
          <GridContainer>
            <GridItem xs={12}>
              <Typography color="black1" fontSize="14px" fontWeight="bold" lineHeight="18px" variant="body2">
                En esta Compra Ágil aplican sanciones en caso de incumplimientos.
              </Typography>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12}>
              <Typography color="black1" fontSize="14px" lineHeight="18px" margin="8px 0" variant="body2">
                Puedes revisar las medidas y procedimientos en caso de incumplimientos que aplican para el proveedor
                seleccionado.
              </Typography>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12}>
              <WrapperDownloadBreach>
                <IconArrowDownward fontSize="small" />
                <DownloadBreach download href={filePath} target="_blank">
                  Medidas derivadas de incumplimientos
                </DownloadBreach>
              </WrapperDownloadBreach>
            </GridItem>
          </GridContainer>
        </Card>
      </GridItem>
    </GridContainer>
  )
}

export default FinesPenalties
